// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1g5p6","filesListContainer":"PosDisputesFiles_filesListContainer__QfvTa","filesButton":"PosDisputesFiles_filesButton__1uGFh"};